/*
 * constants
 */
import {
  // In-App Notification
  LOAD_INAPP_NOTIFICATION,
  LOAD_INAPP_NOTIFICATION_SUCCESS,
  LOAD_INAPP_NOTIFICATION_ERROR,
  CREATE_INAPP_NOTIFICATION,
  CREATE_INAPP_NOTIFICATION_SUCCESS,
  CREATE_INAPP_NOTIFICATION_ERROR,
  UPDATE_INAPP_NOTIFICATION,
  UPDATE_INAPP_NOTIFICATION_SUCCESS,
  UPDATE_INAPP_NOTIFICATION_ERROR,
  DELETE_INAPP_NOTIFICATION,
  DELETE_INAPP_NOTIFICATION_SUCCESS,
  DELETE_INAPP_NOTIFICATION_ERROR,

  // Push Notification
  LOAD_PUSH_NOTIFICATION,
  LOAD_PUSH_NOTIFICATION_SUCCESS,
  LOAD_PUSH_NOTIFICATION_ERROR,
  CREATE_PUSH_NOTIFICATION,
  CREATE_PUSH_NOTIFICATION_SUCCESS,
  CREATE_PUSH_NOTIFICATION_ERROR,
  UPDATE_PUSH_NOTIFICATION,
  UPDATE_PUSH_NOTIFICATION_SUCCESS,
  UPDATE_PUSH_NOTIFICATION_ERROR,
  DELETE_PUSH_NOTIFICATION,
  DELETE_PUSH_NOTIFICATION_SUCCESS,
  DELETE_PUSH_NOTIFICATION_ERROR,

  LOAD_NOTIFY_RECORDS_META_DATA,
  LOAD_NOTIFY_RECORDS_META_DATA_SUCCESS,
  LOAD_NOTIFY_RECORDS_META_DATA_ERROR,
} from './constants';

/*
 * In-App Notification Actions
 */
export function loadInAppNotification(notificationList) {
  return {
    type: LOAD_INAPP_NOTIFICATION,
    notificationList,
  };
}

export function loadInAppNotificationSuccess(notification_list, success) {
  return {
    type: LOAD_INAPP_NOTIFICATION_SUCCESS,
    notification_list,
    success,
  };
}

export function loadInAppNotificationError(error) {
  return {
    type: LOAD_INAPP_NOTIFICATION_ERROR,
    error,
  };
}

export function createInAppNotification(data) {
  return {
    type: CREATE_INAPP_NOTIFICATION,
    data,
  };
}

export function createInAppNotificationSuccess(response, success) {
  return {
    type: CREATE_INAPP_NOTIFICATION_SUCCESS,
    response,
    success,
  };
}

export function createInAppNotificationError(error) {
  return {
    type: CREATE_INAPP_NOTIFICATION_ERROR,
    error,
  };
}

export function updateInAppNotification(data) {
  return {
    type: UPDATE_INAPP_NOTIFICATION,
    data,
  };
}

export function updateInAppNotificationSuccess(response, success) {
  return {
    type: UPDATE_INAPP_NOTIFICATION_SUCCESS,
    response,
    success,
  };
}

export function updateInAppNotificationError(error) {
  return {
    type: UPDATE_INAPP_NOTIFICATION_ERROR,
    error,
  };
}

export function deleteInAppNotification(id) {
  return {
    type: DELETE_INAPP_NOTIFICATION,
    id,
  };
}

export function deleteInAppNotificationSuccess(response, success) {
  return {
    type: DELETE_INAPP_NOTIFICATION_SUCCESS,
    response,
    success,
  };
}

export function deleteInAppNotificationError(error) {
  return {
    type: DELETE_INAPP_NOTIFICATION_ERROR,
    error,
  };
}

/*
 * Push Notification Actions
 */
export function loadPushNotification(notificationList) {
  return {
    type: LOAD_PUSH_NOTIFICATION,
    notificationList,
  };
}

export function loadPushNotificationSuccess(pushNotification_list, success) {
  return {
    type: LOAD_PUSH_NOTIFICATION_SUCCESS,
    pushNotification_list,
    success,
  };
}

export function loadPushNotificationError(error) {
  return {
    type: LOAD_PUSH_NOTIFICATION_ERROR,
    error,
  };
}

export function createPushNotification(data) {
  return {
    type: CREATE_PUSH_NOTIFICATION,
    data,
  };
}

export function createPushNotificationSuccess(response, success) {
  return {
    type: CREATE_PUSH_NOTIFICATION_SUCCESS,
    response,
    success,
  };
}

export function createPushNotificationError(error) {
  return {
    type: CREATE_PUSH_NOTIFICATION_ERROR,
    error,
  };
}

export function updatePushNotification(data) {
  return {
    type: UPDATE_PUSH_NOTIFICATION,
    data,
  };
}

export function updatePushNotificationSuccess(response, success) {
  return {
    type: UPDATE_PUSH_NOTIFICATION_SUCCESS,
    response,
    success,
  };
}

export function updatePushNotificationError(error) {
  return {
    type: UPDATE_PUSH_NOTIFICATION_ERROR,
    error,
  };
}

export function deletePushNotification(id) {
  return {
    type: DELETE_PUSH_NOTIFICATION,
    id,
  };
}

export function deletePushNotificationSuccess(response, success) {
  return {
    type: DELETE_PUSH_NOTIFICATION_SUCCESS,
    response,
    success,
  };
}

export function deletePushNotificationError(error) {
  return {
    type: DELETE_PUSH_NOTIFICATION_ERROR,
    error,
  };
}

export function loadNotifyRecordsMetaData() {
  return {
    type: LOAD_NOTIFY_RECORDS_META_DATA,
  };
}

export function loadNotifyRecordsMetaDataSuccess(recordsMetaData) {
  return {
    type: LOAD_NOTIFY_RECORDS_META_DATA_SUCCESS,
    recordsMetaData,
  };
}

export function loadNotifyRecordsMetaDataError(error) {
  return {
    type: LOAD_NOTIFY_RECORDS_META_DATA_ERROR,
    error,
  };
}
const actions = {
  // In-App Notification
  loadInAppNotification,
  loadInAppNotificationSuccess,
  loadInAppNotificationError,
  createInAppNotification,
  createInAppNotificationSuccess,
  createInAppNotificationError,
  updateInAppNotification,
  updateInAppNotificationSuccess,
  updateInAppNotificationError,
  deleteInAppNotification,
  deleteInAppNotificationSuccess,
  deleteInAppNotificationError,

  // Push Notification
  loadPushNotification,
  loadPushNotificationSuccess,
  loadPushNotificationError,
  createPushNotification,
  createPushNotificationSuccess,
  createPushNotificationError,
  updatePushNotification,
  updatePushNotificationSuccess,
  updatePushNotificationError,
  deletePushNotification,
  deletePushNotificationSuccess,
  deletePushNotificationError,
  loadNotifyRecordsMetaData,
  loadNotifyRecordsMetaDataSuccess,
  loadNotifyRecordsMetaDataError,

};

export default actions;
